module.exports = __webpack_public_path__ + "static/media/whatsapp (1).64955b28.png";